import React from "react"
import { MantineProvider } from "@mantine/core"
import "@mantine/core/styles.css"
import "@fontsource/outfit/300.css"
import "@fontsource/outfit/400.css"
import "@fontsource/outfit/500.css"
import "@fontsource/aleo/300.css"
import "@fontsource/aleo/400.css"
import "@fontsource/aleo/700.css"
import "@fontsource/source-serif-4/300.css"
import "@fontsource/source-serif-4/400.css"
import "@fontsource/source-serif-4/700.css"
import "@fontsource/zilla-slab/300.css"
import "@fontsource/zilla-slab/400.css"
import "@fontsource/zilla-slab/700.css"
import "@fontsource/domine/400.css"
import "@fontsource/domine/700.css"
import "./src/styles/global.css"
import { theme } from "./src/theme"
import type { GatsbyBrowser } from "gatsby"

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => (
  <MantineProvider theme={theme} defaultColorScheme="light">
    {element}
  </MantineProvider>
)
